import type { ListBuilderList } from '../../../types';
import { createActivityListColumns } from '../columns';
import {
	ACTIVITY_LIST_ACTIVE_FILTERS,
	ACTIVITY_LIST_REQUIRED_FIELDS,
	CLIENT_MOBILE_CARD_CONFIG,
	SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
	createClientKanbanConfig,
} from '../shared';

/**
 * Scheduled Today list configuration
 * Clients scheduled for activities today, sorted by activity time
 */
export const scheduledTodayList: ListBuilderList = {
	id: 'scheduled-today-list',
	cacheTTL: 300000,
	name: 'Scheduled Today',
	type: 'default',
	active: true,
	columns: createActivityListColumns(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description:
		'Clients scheduled for activities today, sorted by activity time',
	defaultSortId: 'next-activity-asc',
	requiredFields: ACTIVITY_LIST_REQUIRED_FIELDS,
	filters: {
		activeFilters: ACTIVITY_LIST_ACTIVE_FILTERS,
	},
	sortOrder: 1,
	filterRules: {
		...SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
		callStatus: {
			defaultValue: [
				{
					id: 'Callable',
					label: 'Callable',
				},
			],
		},
		// The Scheduled Today tab is defined BY the scheduled_today special
		// filter — removing it leaves the tab showing the entire client base,
		// which makes no sense. Mark the filter locked so the chip renders
		// without an "x" and can't be cleared.
		specialFilters: {
			locked: true,
			defaultValue: [
				{
					id: 'scheduled_today',
					label: 'Scheduled Today',
				},
			],
		},
	},
	kanbanConfig: createClientKanbanConfig(),
};
